/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Pavel Režňák (reznak@cadwork.cz)
 */

import Layer from "App/render/webgl/layers/layer";
import WebGLRenderGraph from "App/render/webgl/render_graph";
import {Containers} from "App/utils/factory";
import View from "App/view/view";
import HUD from "App/render/webgl/passes/hud";
import Plane from "App/environment/objects/plane";

export default
class HUDLayer extends Layer {
    constructor(aRenderGraph: WebGLRenderGraph) {
        super(aRenderGraph);

        this._shadersID = Containers.SHADERS_HUD;
        this._passesID = Containers.PASSES_HUD;
        this._name = 'HUD';
    }

    /**
     * Render background before anything else
     *
     * @param {View} aView
     */
    public prerender(aView: View) {

        if (!this.readyToRender()) {
            return;
        }

        this._passes.get(HUD.TypeName).renderBackground(
            aView,
            this._renderGraph.getFramebuffersContainer().get("screen")
        );
    }

    /**
     * @param {View} aView
     * @return {boolean}
     * @override
     */
    public render(aView: View): boolean {

        if (!this.readyToRender()) {
            return true;
        }

        this._passes.get(HUD.TypeName).render(
            aView,
            this._renderGraph.getFramebuffersContainer().get("screen")
        );

        return true;
    }

    /**
     *
     * @param {View} aView
     */
    public onResize(aView: View) {
        aView.getHud().testHUDItemsForVisibility();
    }
}
